module.exports = __webpack_public_path__ + "img/car-search-banner.83dbf3b7.svg";